module.exports = __webpack_public_path__ + "img/battery.e8ea9577.svg";